import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppSettingsService from './utils/AppSettingsService';
import AuthService from './utils/AuthService';
import ApiService from './utils/ApiService';

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);

let appSettings = new AppSettingsService();
let authService = new AuthService(appSettings);

let baseApiUri: string = appSettings.GetWebApiBaseUri();
let apiService: ApiService = new ApiService(baseApiUri, authService);

root.render(
  <React.StrictMode>
    <App authServiceInstance={authService} apiService={apiService}/>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
